import React from 'react';
import moment from 'moment';
import { Link } from 'react-router-dom';

import { DATE_TIME_FORMAT } from '../../constants';

const RollingArrangementList = ({ rollingArrangements }) => (
  <table className="table table-striped mar-t">
    <thead>
      <tr>
        <td>
          <strong>Id</strong>
        </td>
        <td>
          <strong>User Profile</strong>
        </td>
        <td>
          <strong>Arrangement Day</strong>
        </td>
        <td>
          <strong>Arranged Until</strong>
        </td>
        <td>
          <strong>Enabled</strong>
        </td>
        <td></td>
      </tr>
    </thead>
    <tbody>
      {rollingArrangements &&
        rollingArrangements.map(
          ({ id, user_profile, arrangement_day, arranged_until, enabled }) => (
            <tr key={id}>
              <td>{id}</td>
              <td>{user_profile}</td>
              <td>{arrangement_day}</td>
              <td>{moment(arranged_until).format(DATE_TIME_FORMAT)}</td>
              <td>{enabled ? 'true' : 'false'}</td>
              <td>
                <Link to={`/rolling-arrangements/${id}/view`}>View</Link>
              </td>
            </tr>
          ),
        )}
      {rollingArrangements && rollingArrangements.length === 0 && (
        <tr>
          <td className="text-center" colSpan={5}>
            No Results
          </td>
        </tr>
      )}
    </tbody>
  </table>
);

export default RollingArrangementList;
